import request from '../requesters/default'
import type { LbgSharedOwnershipTypeRefDataResp } from '../service/mortgage-application'

export const fetchLBGSharedOwnershipCompanyList = async () => {
  const response = await request.get<LbgSharedOwnershipTypeRefDataResp>('/mortgage-application/lbg/ref_data/shared_ownership_type')

  return response.data.shared_ownership_type_ref_data
}